import * as React from 'react';

import { CheckInvitePopup } from './check-invite-popup';
import { SetupAppPopup } from './setup-app-popup';

export interface IModerationConstraintPopupState {
  open: boolean;
  step: number;
}

export interface IModerationConstraintPopupProps {
  address: string;
  offerLink: string;
  isVerificationServiceEnabled: boolean;
  verificationUrl: string;
  onAccept(): void;
  onCancel(e: React.MouseEvent<HTMLElement>): void;
  onClose(e: React.MouseEvent<HTMLElement>): void;
}

export class ModerationConstraintPopup extends React.Component<
  IModerationConstraintPopupProps,
  IModerationConstraintPopupState
> {
  public state = {
    open: true,
    step: 1,
  };

  private handleAcceptClick = () => {
    if (this.props.isVerificationServiceEnabled) {
      window.open(this.props.verificationUrl, '_blank');
    } else {
      this.setState({ step: 2 });
    }
  };

  private handleCancelClick = (e: React.MouseEvent<HTMLElement>) => {
    this.setState({ open: false });
    this.props.onCancel(e);
  };

  private handleClosePopup = (e: React.MouseEvent<HTMLElement>) => {
    this.setState({ open: false });
    this.props.onClose(e);
  };

  private renderSetupApp = () => <SetupAppPopup onCancel={this.handleCancelClick} onClose={this.handleClosePopup} />;

  private renderCheckInvitePopup = () => (
    <CheckInvitePopup
      address={this.props.address}
      offerLink={this.props.offerLink}
      onAccept={this.handleAcceptClick}
      onCancel={this.handleCancelClick}
      onClose={this.handleClosePopup}
    />
  );

  public render() {
    const { open, step } = this.state;

    if (!open) {
      return null;
    }

    // Сначала показываем первый информационный попап, если пользователь согласен, то показываем следующий попап
    // с предложением скачать приложение
    return step === 2 ? this.renderSetupApp() : this.renderCheckInvitePopup();
  }
}
